import React, { SVGAttributes } from 'react';

export const DoubleArrowIcon = (props: SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28" {...props}>
    <path fill="currentColor" d="M22.167 18.083v-5.25L14 18.667l-8.167-5.834v5.25L14 23.917l8.167-5.834z" />
    <path fill="currentColor" d="M22.167 9.917v-5.25L14 10.5 5.833 4.667v5.25L14 15.75l8.167-5.833z" />
  </svg>
);

/* eslint max-len:0 */
